import { Descriptions, Modal, Spin, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import OtpModal from "./OtpModal";
import { fetchPayments } from "../../../../features/fetch/fetchSlice";
import {
  capitalize,
  cashConverter,
  dateForHumans,
  formatDateTime,
  formatPath,
  previewPaper,
  timeAmPm,
} from "../../../../utils";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../../layout/BreadCrumb";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import ConfirmModal from "../../../../components/ConfirmModal";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import { downloadExcel } from "../../../../features/global/globalSlice";

function VerificationTable() {
  const { singlePaymentObj } = useSelector((state) => state.obj);
  const { saving, bulkDetails, bulPaymentHeader } = useSelector(
    (state) => state.save
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [openOtp, setopenOtp] = useState(false);
  async function handleCancelOtp() {
    await setopenOtp(false);
  }

  async function handleOpenOtp() {
    await setopenOtp(true);
  }

  const handleCancelUpload = async () => {
    await navigate("/bulk-payment");
  };
  const { open, handleOpen, handleCancel } = useModalToggle();
  const [content, setContent] = useState();
  const [alert, setAlert] = useState(false);
  const handleOpenConfirm = async () => {
    const hasFailure = bulPaymentHeader?.pyTotalFailed > 0;
    if (hasFailure) {
      await setContent(
        "There are some entries number dont match, do you still wish to proceed?!!"
      );
      await setAlert(true);
    } else {
      await setContent("All records matched, do you wish to proceed");
      await setAlert(false);
    }
    await handleOpen();
  };

const paymentMode = bulPaymentHeader?.pyPaymentMode;

const columns = [
  {
    title: "Created Date",
    dataIndex: "payCreatedDate",
    key: "payCreatedDate",
    render: (item) => <div>{dateForHumans(item)}</div>,
    sorter: (a, b) => a.payCreatedDate - b.payCreatedDate,
  },
  {
    title: "Created Time",
    dataIndex: "payCreatedTime",
    key: "payCreatedTime",
    render: (item) => <div>{timeAmPm(item)}</div>,
    sorter: (a, b) => a.payCreatedTime - b.payCreatedTime,
  }, 
  ...(paymentMode === "PESALINK_BANK"
    ? [
        {
          title: "Beneficiary Account",
          dataIndex: "payBeneficiaryAccount",
          key: "payBeneficiaryAccount",
          sorter: (a, b) =>
            a.payBeneficiaryAccount.localeCompare(b.payBeneficiaryAccount),
        },
        {
          title: "Beneficiary Bank",
          dataIndex: "payBeneficiaryBank",
          key: "payBeneficiaryBank",
          sorter: (a, b) =>
            a.payBeneficiaryBank.localeCompare(b.payBeneficiaryBank),
        },
      ]
    : []),
  {
    title: "Payment Reason",
    dataIndex: "payPaymentReason",
    key: "payPaymentReason",
    sorter: (a, b) => a.payPaymentReason.localeCompare(b.payPaymentReason),
  },
  {
    title: "Mobile Number",
    dataIndex: "payReceiverMobileNo",
    key: "payReceiverMobileNo",
    sorter: (a, b) =>
      a.payReceiverMobileNo.localeCompare(b.payReceiverMobileNo),
  },
  {
    title: "Amount",
    dataIndex: "payPaymentAmount",
    key: "payPaymentAmount",
    render: (item) => <div>{cashConverter(item)}</div>,
    sorter: (a, b) => a.payPaymentAmount - b.payPaymentAmount,
  },
  {
    title: "Receiver Name",
    dataIndex: "payReceiverName",
    key: "payReceiverName",
    sorter: (a, b) => a.payReceiverName.localeCompare(b.payReceiverName),
  },
  {
    title: "Pay Status",
    dataIndex: "payStatus",
    key: "payStatus",
    render: (item) => (
      <div
        className={`${
          item === "FAILURE"
            ? "bg-[#FF4D4F]"
            : item === "INVALID"
            ? "bg-[#FFA500]"
            : item === "Timed out at agent"
            ? "bg-[#FF8C00]"
            : item === "SUCCESS"
            ? "bg-darkGreen"
            : item === "PROCESSING"
            ? "bg-[#FF6F00]"
            : "bg-[#1890FF]"
        } text-[#fff] inline-block rounded-[5px] px-2 py-1`}
      >
        {item}
      </div>
    ),
  },
];


  const [resMess, setResMess] = useState();

  const onFinish = async () => {
    const res = await dispatch(
      save({
        url: `payment-staging/save-payments?bulkUploadId=${bulPaymentHeader?.pyId}`,
      })
    );
    if (res?.payload?.success) {
      if (res?.payload?.data?.result?.hasReviewers) {
        await toast.success(res?.payload?.messages?.message);
        await navigate("/bulk-payment");
      } else {
        await setResMess(res?.payload?.data?.result);
        await handleCancel();
        await handleOpenOtp();
      }
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const breadList = [
    {
      title: (
        <div className="flex items-center gap-[.25rem] cursor-pointer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <g clipPath="url(#clip0_627_13942)">
              <path
                d="M13.7899 6.89067L7.75241 0.856289L7.34772 0.451602C7.25551 0.360003 7.13082 0.308594 7.00085 0.308594C6.87087 0.308594 6.74618 0.360003 6.65397 0.451602L0.211783 6.89067C0.117301 6.98478 0.0426296 7.09687 -0.00782254 7.22031C-0.0582747 7.34376 -0.0834854 7.47607 -0.0819665 7.60942C-0.0757165 8.15942 0.382096 8.59848 0.932096 8.59848H1.59616V13.6875H12.4055V8.59848H13.0837C13.3508 8.59848 13.6024 8.49379 13.7915 8.30473C13.8846 8.21193 13.9583 8.10159 14.0085 7.98009C14.0586 7.8586 14.0842 7.72836 14.0837 7.59692C14.0837 7.33129 13.979 7.07973 13.7899 6.89067ZM7.87585 12.5625H6.12585V9.37504H7.87585V12.5625ZM11.2805 7.47348V12.5625H8.87585V9.00004C8.87585 8.65473 8.59616 8.37504 8.25085 8.37504H5.75085C5.40553 8.37504 5.12585 8.65473 5.12585 9.00004V12.5625H2.72116V7.47348H1.22116L7.00241 1.69691L7.36335 2.05785L12.7821 7.47348H11.2805Z"
                fill="black"
                fillOpacity="0.45"
              />
            </g>
            <defs>
              <clipPath id="clip0_627_13942">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span onClick={() => navigate("/bulk-payment")}>
            Bulk Payment Details
          </span>
        </div>
      ),
    },
    {
      title: capitalize("Bulk Payments Verification"),
    },
  ];

  const handleDownload = async (item) => {
    const res = await dispatch(
      downloadExcel({
        url:`payment-staging/view-uploaded-file?fileName=${item?.pyFileName}`,
      })
    );
    if (res?.payload) {
      const blobData = res.payload.data;
      const headers = res.payload.headers;

      const contentType = headers["content-type"] || "application/octet-stream";
      const contentDisposition = headers["content-disposition"];

      let fileName = "Upload_template";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }
      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      await toast.success(`${fileName} downloaded successfully`);
    } else {
      toast.error("Failed to download file");
    }
  };
  const items = [
    {
      key: "2",
      label: "File Name",
      children:<div className="cursor-pointer text-blu underline" onClick={()=>handleDownload(bulPaymentHeader)}>{formatPath(bulPaymentHeader?.pyFileName)}</div> ,
    },
    {
      key: "3",
      label: "Total Failed",
      children: (
        <div className="text-[#FF4D4F]">{bulPaymentHeader?.pyTotalFailed}</div>
      ),
    },
    {
      key: "4",
      label: "Total Successful",
      children: (
        <div className="text-darkGreen">
          {bulPaymentHeader?.pyTotalSuccessful}
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col w-full h-full overflow-y-auto pb-[100px]">
      <div className="flex-1">
        <div className="justify-between items-center white_card">
          <BreadCrumb
            breadList={breadList}
            header={"Bulk Payments Verification"}
            info={"Would you like to make the following transfer?"}
          />
        </div>

        <div className="mt-[1.25rem] white_card flex flex-col">
          <Descriptions
            column={{
              xxl: 3,
              xl: 3,
              lg: 2,
              md: 2,
              sm: 1,
              xs: 1,
            }}
            colon={false}
            title="Payment Header Summary"
            items={items}
          />

          <div className="mt-[1.25rem] flex flex-col">
            <Table
              rowSelection={false}
              className="mt-[1.31rem] w-full"
              scroll={{
                x: 800,
              }}
              rowKey={(record) => record?.payId}
              columns={columns}
              dataSource={bulkDetails}
              loading={saving}
              pagination={{
                pageSize: 10,
                showSizeChanger: false,
              }}
            />
          </div>
        </div>
      </div>

      <div className="fixed bottom-6 right-6 z-50 flex lg:flex-row flex-col items-center gap-x-2">
        <button
          key="back"
          type="button"
          onClick={handleCancelUpload}
          className="cstm-btn !w-[200px]"
        >
          Upload Again
        </button>

        <button
          key="submit"
          type="submit"
          className="cstm-btn-2 !w-[200px]"
          onClick={handleOpenConfirm}
          disabled={saving}
        >
          {saving ? <Spin /> : "Complete Payment"}
        </button>
      </div>

      <OtpModal
        open={openOtp}
        handleCancel={handleCancelOtp}
        resMess={resMess}
      />

      <ConfirmModal
        open={open}
        handleCancel={handleCancel}
        handleSubmit={onFinish}
        loading={saving}
        content={content}
        type={alert ? "alert" : "info"}
        btnTitle="Confirm"
      />
    </div>
  );
}

export default VerificationTable;
